import { BehaviorSubject } from 'rxjs';

const bettingModeModal$ = new BehaviorSubject(false);

const displayBettingModeModal = (isShow: boolean) => {
	bettingModeModal$.next(isShow);
}

export const bettingModeService = {
	bettingModeModal$: bettingModeModal$.asObservable(),
	displayBettingModeModal
};